import Sidebar from "./Sidebar";

function Dashboard() {
  return (
    <div className="container-fluid">
      <div className="row">

        <div className="col-md-3 col-lg-2 p-0">
          <Sidebar />
        </div>

        <div className="col-md-9 col-lg-10 p-4">
          <h2>Dashboard</h2>
          <p>Welcome to City Dental Admin Panel</p>
        </div>

      </div>
    </div>
  );
}

export default Dashboard;